export const SHOW_ACTIVITY = 'SHOW_ACTIVITY';
export const HAS_ERROR = 'HAS_ERROR';
export const IS_CONTENT_LOADING = 'IS_CONTENT_LOADING';
export const IS_PAGE_LOADING = 'IS_PAGE_LOADING';
export const SHOW_COLLECTION = 'SHOW_COLLECTION';
export const UPDATE_CURRENT_COLLECTION = "UPDATE_CURRENT_COLLECTION";
export const AFFILIATE_COLLECTION = "AFFILIATE_COLLECTION";
export const SAVE_FILTERED_ACTIVITIES = "SAVE_FILTERED_ACTIVITIES";
export const FILTER_APPLIED = "FILTER_APPLIED";
export const LOCATION_FILTER_APPLIED = "LOCATION_FILTER_APPLIED";
export const CATEGORY_FILTER_APPLIED = "CATEGORY_FILTER_APPLIED";
export const AFFILIATE_LOGO = "AFFILIATE_LOGO";

export const PAGE_NOT_FOUND = 'PAGE_NOT_FOUND';


export const AFFILIATE_API_PATH = "/affiliate/api/vdev/";//window.location.protocol+"//"+window.location.hostname+'/affiliate/api/vdev/';
export const ROOT_API_PATH = "/";//window.location.protocol+"//"+window.location.hostname+"/";



// WEBPACK FOOTER //
// ./src/actions/constant.js